import React, { useState, useRef, useEffect } from 'react';

const ContentChoosing= () => {
  const ChoosingData = [
    {
      heading: "Affordability",
      description: "We offer competitive pricing plans tailored to meet the budgetary constraints of businesses, startups, and individuals, ensuring accessibility and affordability for all.",
    },
    {
      heading: "Quality and Expertise",
      description: "Despite offering affordable solutions, we never compromise on quality. Our team of experienced writers and editors ensures that all content is well-researched, informative, and engaging, meeting the highest standards of quality and professionalism.",
    },
    {
      heading: "Customization and Flexibility",
      description: "We work closely with clients to understand their unique needs and objectives, delivering customized content solutions that align with their brand identity, target audience, and business goals.",
    },
    {
      heading: "Timeliness and Consistency",
      description: "We understand the importance of timeliness and consistency in content production. Our team works diligently to deliver content on time, every time, ensuring a steady stream of fresh and relevant content to keep audiences engaged and informed.",
    }
  ];

  return (
    <div  className="col-lg-6">
    <div className="accordions-new is-first-expanded">
      {ChoosingData.map((item, index) => (
        <AccordionItem key={index} title={item.heading} content={item.description} />
      ))}
    </div>
    </div>
  );
};

const AccordionItem = ({ title, content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const contentRef = useRef(null);

  const toggleAccordion = () => {
    setIsOpen(!isOpen);
  };

  useEffect(() => {
    if (contentRef.current) {
      if (isOpen) {
        contentRef.current.style.maxHeight = contentRef.current.scrollHeight + 'px';
      } else {
        contentRef.current.style.maxHeight = '0px';
      }
    }
  }, [isOpen]);

  return (
    <article className="accordion">
      <div className="accordion-head" onClick={toggleAccordion}>
        <span>{title}</span>
        <span className={`icon ${isOpen ? 'open' : ''}`}>
          <i className={`fa ${isOpen ? 'fa-chevron-down' : 'fa-chevron-right'}`}></i>
        </span>
      </div>
      <div
        ref={contentRef}
        className={`accordion-body ${isOpen ? 'open' : ''}`}
        style={{ maxHeight: isOpen ? `${contentRef.current?.scrollHeight}px` : '0px' }}
      >
        <div className="content">
          <p>{content}</p>
        </div>
      </div>
    </article>
  );
};

export default ContentChoosing;
